import React from "react";
import "./header.scss";

const Header = () => {
  return (
    <div className="header-container">
      <h1 className="header-title">Things To Do</h1>
    </div>
  );
};

export default Header;
